import { useCallback } from "react";

import type { RegistrationStatusType } from "@/lib/gql/__generated__/graphql";

import type * as FormModelType from "@/components/features/invoice-system-settings/model/type";

export const useActions = (
	viewModel: FormModelType.InvoiceSystemSettingsFormModel["ViewModel"],
	onSetViewModel: (viewModel: FormModelType.InvoiceSystemSettingsFormModel["ViewModel"]) => void,
) => {
	const onChangeRegistrationStatus = useCallback(
		(value: RegistrationStatusType) => {
			onSetViewModel({
				...viewModel,
				registrationStatus: {
					...viewModel.registrationStatus,
					value,
				},
			});
		},
		[onSetViewModel, viewModel],
	);

	const onChangeRegistrationCode = useCallback(
		(value: number | undefined) => {
			onSetViewModel({
				...viewModel,
				registrationCode: {
					value: value ? String(value) : undefined,
					isEdited: viewModel.registrationCode?.isEdited || false,
					error: viewModel.registrationCode?.error || undefined,
				},
			});
		},
		[onSetViewModel, viewModel],
	);

	return {
		onChangeRegistrationStatus,
		onChangeRegistrationCode,
	};
};
